(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flagship-series"] && !Shopify.designMode) return;
  try {
    
  // 动态适配背景图（原有逻辑保留）
  document.addEventListener('DOMContentLoaded', function() {
    // 处理存储区banner背景图
    const storageBanner = document.querySelector('.flagship-series__storage-banner');
    if (storageBanner) {
      const updateStorageBannerBg = function() {
        if (window.innerWidth <= 768) {
          const mobileBg = storageBanner.dataset.mobileBg;
          if (mobileBg) {
            storageBanner.style.backgroundImage = `url(${mobileBg})`;
          }
        } else {
          const desktopBg = storageBanner.dataset.desktopBg;
          if (desktopBg) {
            storageBanner.style.backgroundImage = `url(${desktopBg})`;
          }
        }
      };
      
      updateStorageBannerBg();
      window.addEventListener('resize', updateStorageBannerBg);
    }
    
    // 处理扩展坞区banner背景图
    const dockingBanner = document.querySelector('.flagship-series__docking-banner');
    if (dockingBanner) {
      const updateDockingBannerBg = function() {
        if (window.innerWidth <= 768) {
          const mobileBg = dockingBanner.dataset.mobileBg;
          if (mobileBg) {
            dockingBanner.style.backgroundImage = `url(${mobileBg})`;
          }
        } else {
          const desktopBg = dockingBanner.dataset.desktopBg;
          if (desktopBg) {
            dockingBanner.style.backgroundImage = `url(${desktopBg})`;
          }
        }
      };
      
      updateDockingBannerBg();
      window.addEventListener('resize', updateDockingBannerBg);
    }
    
    // Hotspot触摸优化（移动端新增）
    const hotspots = document.querySelectorAll('.flagship-series__hotspot');
    hotspots.forEach(hotspot => {
      hotspot.addEventListener('touchstart', function(e) {
        e.stopPropagation();
      }, { passive: true });
      
      hotspot.addEventListener('touchend', function(e) {
        e.stopPropagation();
        const href = this.getAttribute('href');
        if (href && href !== '#') {
          window.location.href = href;
        }
      }, { passive: true });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
